<template>
  <div class="page-wrap">
    <!-- ========== 新增顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <!-- 移动端汉堡按钮 -->
        <div v-if="isMobile" class="hamburger-btn" @click="mobileMenuDrawer = true" @openSubMenu="openSubMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div class="header-right">
        <!-- 系统消息图标 -->
        <div class="header-icon">
          <i class="el-icon-bell"></i>
        </div>
        <!-- 账户下拉菜单 -->
        <div v-if="visible_loginMenu">
          <el-dropdown trigger="click" @command="handleAccountCommand">
            <div class="header-icon user-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info">资产</el-dropdown-item>
              <el-dropdown-item command="logout" divided style="color: #f53f3f">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else>
          <div class="header-icon user-icon" @click="login">
            <i class="el-icon-user"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- PC端：左侧导航 外层容器包裹两个组件 -->
    <div v-if="!isMobile" class="sidebar-wrap">
      <LeftSide :in-drawer="false" @openSubMenu="openSubMenu" />
    </div>
    <TopSide @openSubMenu="openSubMenu2" />
    <!-- 移动端左侧抽屉菜单 -->
    <el-drawer v-model="mobileMenuDrawer" direction="ltr" size="240px" :with-header="false">
      <LeftSide @openSubMenu="handleMobileSubMenu" />
    </el-drawer>

    <!-- 主体内容区域：【左作品列表 ｜ 右上传表单区域】 -->
    <div class="main-content">
      <div class="main-inner">
        <div class="replicate-layout">
          <!-- ========= 左侧：全部作品列表 ========= -->
          <div class="preview-card-wrap">
            <div class="works-list-card">
              <div class="works-tabs">
                <span class="works-tab" :class="{ active: currentTab === 'all' }" @click="currentTab = 'all'">全部</span>
                <span class="works-tab" :class="{ active: currentTab === 'replicate' }" @click="currentTab = 'replicate'" v-if="false">复刻作品</span>
                <!-- 新增：清空缓存按钮 -->
                <el-button size="mini" type="text" style="margin-left: auto; color: #ff8888" @click="clearWorkCache">清空作品缓存</el-button>
              </div>
              <div class="works-grid">
                <div class="works-item" v-for="(img, idx) in filterImgList" :key="idx" @click="openImagePreview(img)">
                  <img :src="img.src" alt="" />
                  <div class="works-item-info">{{ img.text }}</div>
                </div>
              </div>
              <div class="works-empty" v-if="filterImgList.length === 0">暂无作品</div>
            </div>
          </div>

          <!-- ========= 右侧：标题 + 上传区 + 示例小样 + 表单按钮 ========= -->
          <div class="form-panel">
            <div class="page-title">
              <h1>一键{{ type === '1' ? '抠图' : '商品精修'}}</h1>
            </div>

            <!-- 拖拽上传大框 -->
            <div class="upload-large-wrap">
              <el-upload ref="uploadRefRef" action="" :auto-upload="false" :limit="1" accept="image/jpeg,image/png,image/webp" :show-file-list="false" :on-change="handleRefDemoImgChange" drag>
                <div class="drag-upload-inner">
                  <i class="el-icon-upload upload-icon"></i>
                  <div class="upload-main-text">点击或拖拽图片上传</div>
                  <div class="upload-desc">支持 JPG / PNG 格式</div>
                </div>
              </el-upload>
            </div>

            <!-- 没有图片？试试这些 示例小样图 -->
            <div class="demo-sample-block">
              <div class="sample-divider">
                <span class="sample-text">没有图片？试试这些</span>
              </div>
              <div class="sample-img-list">
                <div class="sample-item" v-for="(item, idx) in sampleImgList" :key="idx" @click="selectSampleImg(item)">
                  <img :src="item.src" alt="sample" />
                </div>
              </div>
            </div>

            <!-- 参考图预览 -->
            <div class="form-item">
              <label class="form-label">已上传图片<span class="required">*</span></label>
              <div class="upload-card-wrap">
                <div class="img-preview-list" v-if="demoRefImgList.length > 0">
                  <div class="preview-item" v-for="(url, idx) in demoRefImgList" :key="idx">
                    <img :src="url" alt="" />
                    <i class="el-icon-close close-icon" @click="removeDemoRefImg(idx)"></i>
                  </div>
                </div>
                <div class="upload-count">{{ demoRefImgList.length }}/1</div>
              </div>
            </div>

            <!-- 操作按钮 -->
            <div class="form-item">
              <el-button type="primary" size="large" class="submit-btn" @click="runReplicateGenerate" :loading="generating"> 一键{{ type === '1' ? '扣除背景' : type === '2' ? '精修' : '扣除背景' }} </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== 大图预览弹窗 ========== -->
    <div class="preview-mask" v-if="previewVisible" @click.self="closePreview">
      <div class="preview-box">
        <i class="el-icon-close preview-close" @click="closePreview"></i>
        <img class="preview-img" :src="currentPreviewImg.src" alt="" />
        <div class="preview-toolbar">
          <el-button type="primary" size="small" @click="downloadImage" v-if="isMember"> <i class="el-icon-download"></i> 下载保存 </el-button>
        </div>
      </div>
    </div>

    <!-- ========== 右侧抽屉：电商图子菜单 ========== -->
    <el-drawer :visible.sync="subDrawerVisible" direction="rtl" size="260px" title="电商图设计" :before-close="closeSubDrawer">
      <div class="sub-menu-list">
        <div class="sub-menu-item" v-for="subItem in subMenuList" :key="subItem.path" @click="goPage(subItem.path)">
          <i :class="subItem.icon"></i>
          <span>{{ subItem.title }}</span>
        </div>
      </div>
    </el-drawer>

    <div class="float-input-panel" :class="{ hidePanel: !showBottomInput }">
      <div class="float-input-box">
        <div class="float-input-left">
          <i class="el-icon-plus float-add-icon"></i>
        </div>
        <textarea class="float-textarea" placeholder='输入想法、剧本或上传参考,支持 "/" 使用技能,@ 添加主体,和Agent一起创作'></textarea>
        <div class="float-input-right">
          <el-button size="mini" class="float-btn">
            <i class="el-icon-microphone"></i>
          </el-button>
          <el-button type="primary" class="float-send-btn">
            <i class="el-icon-top"></i>
          </el-button>
        </div>
      </div>
      <div class="float-quick-tags">
        <span class="quick-tag">智能生成</span>
        <span class="quick-tag">图片生成</span>
        <span class="quick-tag">视频生成</span>
        <span class="quick-tag">数字人</span>
        <span class="quick-tag">商品图</span>
      </div>
    </div>
  </div>
</template>

<script>
import TopSide from '@/components/TopSide.vue'
import LeftSide from '@/components/LeftSide.vue'
export default {
  components: { LeftSide, TopSide },
  props: ['type'], // 页面类型
  data() {
    return {
      userPrompt: '',
      visible_loginMenu: !!window.sessionStorage.getItem('token'),
      isMember: parseInt(window.sessionStorage.getItem('isMember')) > 0, // 是否是会员
      isMobile: false,
      mobileMenuDrawer: false,
      generating: false,
      subDrawerVisible: false,
      showBottomInput: false,

      sampleImgList: [],
      outputPreviewUrl: '',

      // 只保留参考图,删除商品图相关变量
      demoRefImgList: [],
      demoRefFileList: [],

      replicateMode: 'style',
      selectedPlatform: 'taobao',
      selectedRatio: '1:1',
      goodsRequire: '',

      previewVisible: false,
      currentPreviewImg: {},

      currentTab: 'all',
      imgList: [],

      subMenuList: [
        { title: '商品主图', icon: 'el-icon-picture', path: '/zhutu' },
        { title: 'A+详情', icon: 'el-icon-document', path: '/xiangqing' },
        { title: '爆款图复刻', icon: 'el-icon-s-platform', path: '/baokuang' }
      ]
    }
  },
  created() {
    const cacheStr = window.sessionStorage.getItem('replicateImgList')
    if (cacheStr) {
      try {
        this.imgList = JSON.parse(cacheStr)
      } catch (e) {
        console.warn('缓存解析失败')
      }
    }
  },
  computed: {
    filterImgList() {
      if (this.currentTab === 'all') return this.imgList
      return this.imgList.filter((img) => img.type === 'replicate')
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
    window.addEventListener('scroll', this.debounceCheckScroll)
    this.checkScroll()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
    window.removeEventListener('scroll', this.debounceCheckScroll)
    this.demoRefImgList.forEach((u) => URL.revokeObjectURL(u))
  },
  methods: {
 
    // 清空作品缓存
    clearWorkCache() {
      this.$confirm('确定要清空本地保存的全部作品吗？此操作不可恢复', '提示', {
        confirmButtonText: '确定清空',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          window.sessionStorage.removeItem('replicateImgList')
          this.imgList = []
          this.$message.success('已清空本地作品缓存')
        })
        .catch(() => {})
    },

    selectSampleImg(item) {
      console.log('选中示例图', item)
    },

    handleRefDemoImgChange(file) {
      if (!file.raw) return
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.warning('图片不能大于5MB')
        return
      }
      this.demoRefFileList.push(file.raw)
      const previewUrl = URL.createObjectURL(file.raw)
      this.demoRefImgList.push(previewUrl)
      this.outputPreviewUrl = previewUrl
    },
    removeDemoRefImg(idx) {
      URL.revokeObjectURL(this.demoRefImgList[idx])
      this.demoRefImgList.splice(idx, 1)
      this.demoRefFileList.splice(idx, 1)
      if (this.demoRefImgList.length === 0) this.outputPreviewUrl = ''
      this.$nextTick(() => {
        if (this.$refs.uploadRefRef) {
          this.$refs.uploadRefRef.clearFiles()
        }
      })
    },

    // AI帮写
    handleAiWrite() {
      const platformMap = {
        taobao: '用于淘宝天猫1688风格的图片',
        jd_douyin: '用于京东抖音国内电商的图片',
        foreign: '用于外贸跨境电商,要求纯英文版本的设计图'
      }
      const suffix = platformMap[this.selectedPlatform]
      const defaultText = `产品名称：\n核心卖点：\n适用人群：\n期望场景：\n参数：\n${suffix}`
      if (this.goodsRequire.trim()) {
        this.goodsRequire = this.goodsRequire.trim() + '\n' + suffix
      } else {
        this.goodsRequire = defaultText
      }
      this.$message.success('AI帮写已填充内容')
    },

    // 生成：去掉商品图校验,只校验已上传图片
    async runReplicateGenerate() {
      if (this.generating) return
      const guestMob = window.sessionStorage.getItem('guest_mob') || ''
      // console.log(guestMob)
      if (this.generating) return

      if (guestMob.length === 0) {
        this.$router.push('/mob')
        return
      }
      if (this.demoRefFileList.length === 0) {
        this.$message.warning('请先上传图片')
        return
      }
      this.generating = true

      try {
        const text01 = '精准抠出图片里的商品主体,完整保留产品轮廓、边角、细微凸起缝隙,去除原图全部背景,生成无缝纯白色背景,产品原样不变,不修改产品造型、颜色、logo、细节,无白边、无锯齿、无虚影,边缘干净锐利,电商白底抠图效果'
        const text02 = '商业静物精修,超清,产品居中摆放,严格保留原图产品形状、LOGO、文字、结构不变,清除污渍、划痕、指纹、黑点、杂反光,优化整体光影,高光不过曝、阴影不死黑,材质质感真实自然,整体通透干净,无缝纯白背景,边缘干净顺滑,无锯齿,色彩忠于实物,不夸张调色,棚拍柔光效果,写实电商主图,无变形、无AI篡改'
        this.userPrompt = this.type === 1 ? text01 : text02
        const { data: resCheck } = await this.$http.post('api', {
          C_type: 'ai_upload',
          content: this.userPrompt,
          guest_mob: guestMob,
          type: (parseInt(this.type) + 4)
        })

        if (resCheck.status === 202) {
          this.$message.error('余额不足，请充值')
          // 移除加载消息
          this.chatList.pop()
          return
        }

        const formData = new FormData()
        // 只传参考图
        this.demoRefFileList.forEach((f) => formData.append('ref_demo_images', f))

        formData.append('replicate_mode', this.replicateMode)
        formData.append('platform', this.selectedPlatform)
        formData.append('aspect_ratio', this.selectedRatio)
        // formData.append('prompt', this.goodsRequire)
        formData.append('guest_mob', guestMob)
        formData.set(
          'prompt', this.type === 1 ? text01 : text02
          )

        const res = await this.$http.post('/api/image-images', formData)
        if (res.data.code === 200) {
          const imageData = res.data.data.data[0]
          this.imgList.unshift({
            src: imageData.url,
            text: this.goodsRequire,
            type: 'replicate'
          })
          this.outputPreviewUrl = imageData.url
          window.sessionStorage.setItem('replicateImgList', JSON.stringify(this.imgList))
          this.$message.success('生成成功！')
        } else {
          this.$message.error(res.data.msg || '生成失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('网络异常,请稍后重试')
      } finally {
        this.generating = false
      }
    },

    checkDevice() {
      this.isMobile = window.innerWidth <= 768
      if (this.isMobile) this.mobileMenuDrawer = false
    },
    debounceCheckScroll: (function () {
      let timer = null
      return function () {
        clearTimeout(timer)
        timer = setTimeout(() => this.checkScroll(), 100)
      }
    })(),
    checkScroll() {
      this.showBottomInput = window.scrollY > 120
    },

    handleMobileSubMenu() {
      this.openSubMenu()
      this.mobileMenuDrawer = false
    },
    openSubMenu() {
      this.subDrawerVisible = true
    },
    openSubMenu2() {},
    closeSubDrawer(done) {
      done()
    },
    goPage(routePath) {
      this.$router.push(routePath)
      this.subDrawerVisible = false
    },

    openImagePreview(imgItem) {
      this.currentPreviewImg = imgItem
      this.previewVisible = true
      document.body.style.overflow = 'hidden'
    },
    closePreview() {
      this.previewVisible = false
      document.body.style.overflow = ''
    },
    async downloadImage() {
      try {
        const imgUrl = this.currentPreviewImg.src
        const a = document.createElement('a')
        a.href = imgUrl
        a.download = '处理后图片'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (err) {
        this.$message.info('图片存在跨域限制,请右键图片另存为')
      }
    },

    handleAccountCommand(command) {
      switch (command) {
        case 'info':
          this.$router.push('/zichan')
          break
        case 'logout':
          this.exit()
          this.$message.success('退出登录')
          break
      }
    },
    login() {
      this.$router.push('/mob')
    },
    exit() {
      window.sessionStorage.setItem('token', '')
      window.sessionStorage.setItem('tokenUserType', 0)
    }
  }
}
</script>

<style scoped>
/* 全局改为白色背景 */
.page-wrap {
  background-color: #ffffff;
  min-height: 100vh;
  padding-top: 56px;
  display: flex;
}

.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.header-left {
  display: flex;
  align-items: center;
}

.hamburger-btn {
  width: 36px;
  height: 36px;
  background: #f3f4f6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  color: #333;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  border: 1px solid #e5e7eb;
}

.header-icon:hover {
  color: #409eff;
  border-color: #409eff;
}

.sidebar-wrap {
  width: 120px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 40px 20px 100px;
  box-sizing: border-box;
}

.main-inner {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

/* 重点：左右卡片高度对齐,align-items: stretch,保证上下对齐 */
.replicate-layout {
  display: flex;
  gap: 32px;
  align-items: stretch;
}

.preview-card-wrap {
  width: 48%;
  flex-shrink: 0;
  display: flex;
}

.works-list-card {
  width: 100%;
  background: #f7f8fa;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e5e7eb;
  color: #1f2937;
  overflow-y: auto;
}

.works-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.works-tab {
  font-size: 14px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 0;
}

.works-tab.active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.works-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.works-item {
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  cursor: pointer;
  transition: transform 0.2s;
  border: 1px solid #e5e7eb;
}

.works-item:hover {
  transform: scale(1.02);
}

.works-item img {
  width: 100%;
  display: block;
  aspect-ratio: 1;
  object-fit: cover;
}

.works-item-info {
  padding: 10px;
  font-size: 13px;
  color: #374151;
  line-height: 1.4;
}

.works-empty {
  color: #9ca3af;
  text-align: center;
  padding: 60px 20px;
  font-size: 14px;
}

.form-panel {
  width: 48%;
  background: #f7f8fa;
  border-radius: 16px;
  padding: 32px 28px;
  border: 1px solid #e5e7eb;
  color: #1f2937;
  flex-shrink: 0;
}

.page-title {
  text-align: center;
  margin-bottom: 24px;
}

.page-title h1 {
  font-size: 26px;
  color: #1f2937;
  margin: 0;
}

.upload-large-wrap {
  border: 1px dashed #b4bccc;
  border-radius: 14px;
  padding: 36px 16px;
  margin-bottom: 24px;
  text-align: center;
  background: #ffffff;
}

.drag-upload-inner {
  text-align: center;
  color: #4b5563;
}

.upload-icon {
  font-size: 42px;
  color: #409eff;
}

.upload-main-text {
  font-size: 18px;
  margin: 8px 0 6px;
}

.upload-desc {
  font-size: 13px;
  color: #6b7280;
}

.demo-sample-block {
  margin-bottom: 28px;
}

.sample-divider {
  display: flex;
  align-items: center;
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 16px;
}

.sample-divider::before,
.sample-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e5e7eb;
}

.sample-text {
  padding: 0 12px;
}

.sample-img-list {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.sample-item {
  width: 90px;
  height: 90px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e5e7eb;
}

.sample-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
}

.required {
  color: #ff7878;
}

.row-flex {
  display: flex;
  gap: 12px;
}

.form-col {
  flex: 1;
}

.upload-card-wrap {
  position: relative;
}

.img-preview-list {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.preview-item {
  width: 64px;
  height: 64px;
  position: relative;
}

.preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #d1d5db;
}

.close-icon {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #222;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.upload-count {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 12px;
  color: #666;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.submit-btn {
  width: 100%;
}

.preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.82);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
}

.preview-box {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-close {
  position: absolute;
  top: -36px;
  right: 0;
  font-size: 26px;
  color: #fff;
  cursor: pointer;
}

.preview-img {
  max-width: 100%;
  max-height: 82vh;
  border-radius: 6px;
  display: block;
}

.preview-toolbar {
  text-align: center;
  margin-top: 14px;
}

.sub-menu-list {
  padding-top: 12px;
}

.sub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
}

.sub-menu-item:hover {
  background: #f0f9fe;
  color: #409eff;
}

.sub-menu-item i {
  font-size: 16px;
}

.float-input-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px 24px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 1;
  transform: translateY(0);
}

.float-input-panel.hidePanel {
  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;
}

.float-input-box {
  width: 100%;
  max-width: 820px;
  background: #ffffff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.float-input-left {
  width: 36px;
  height: 36px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
}

.float-add-icon {
  color: #999;
  font-size: 16px;
}

.float-textarea {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  height: 42px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.float-textarea::placeholder {
  color: #999;
}

.float-input-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.float-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #dde5ee;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #409eff;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-quick-tags {
  width: 100%;
  max-width: 820px;
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.quick-tag {
  font-size: 13px;
  color: #666;
  background: #f5f7fa;
  border: 1px solid #e8edf2;
  border-radius: 20px;
  padding: 6px 10px;
  cursor: pointer;
}

.quick-tag:hover {
  color: #409eff;
  border-color: #ccebfa;
  background: #f0f9fe;
}

@media (max-width: 1024px) {
  .replicate-layout {
    flex-direction: column;
  }

  .preview-card-wrap,
  .form-panel {
    width: 100%;
  }

  .works-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .row-flex {
    flex-direction: column;
  }

  .works-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .works-grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .sample-img-list {
    gap: 8px;
  }

  .sample-item {
    width: 70px;
    height: 70px;
  }
}
</style>
